import { Injectable } from '@angular/core';
import { Edge, Node } from '@swimlane/ngx-graph';

import { Employee } from '../../../models/Employees';
import { Relative } from '../../../models/Relative';
import { UtilityTs } from '../../../util/utilityTs';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SwimService {
    links: Edge[] = [];
    nodes: Node[] = [];
    update$: Subject<boolean> = new Subject();


    createEmpNode(emp: Employee) {
        let spouse = this.nodes.find(x => x.data.spouse_id == emp.id);
        if (spouse) {
            return null;
        }
        let found = this.nodes.find(x => x.id == emp.id)
        if (!found) {
            let node: any = {
                id: emp.id,
                label: emp.user.name + " Ji",
            };

            node.data = { url: emp.user.url ? emp.user.url : emp.user.gender == 'MALE' ? './assets/imgs/male.png' : './assets/imgs/female.png' }
            if (emp.user.dob) {
                node["age"] = UtilityTs.getAge(emp.user.dob);
                node["gender"] = emp.user.gender;
            }
            this.nodes.push(node);
            return node;
        } else {
            return found;
        }
    }

    createNodeForRelatives(relative: Relative, relativeList: Relative[]) {
        let excluded = ['Husband', 'Wife', 'Mother'];
        if (!excluded.includes(relative.relation)) {
            let males = ['Brother', 'Father', 'Son', 'Husband'];
            let found = this.nodes.find(x => x.id == relative.relative_id)
            if (relative.relation == 'Father') {
                let mother = relativeList.find(x => x.relation == 'Mother');
                if (mother) {
                    let found = this.nodes.find(x => x.id == mother.relative_id)
                    if (found) {
                        return true;
                    }
                }
            }
            if (!found) {
                let node: any = {
                    id: relative.relative_id,
                    label: relative.name + " Ji",
                };
                node.data = { url: relative.url ? relative.url : males.includes(relative.relation) ? './assets/imgs/male.png' : './assets/imgs/female.png' }
                if (relative.dob) {
                    node["age"] = UtilityTs.getAge(relative.dob);
                    node["gender"] = relative.gender;
                    node["gotra"] = relative.gotra;
                }
                if (relative.death) {
                    if (!node.label.includes("Late")) {
                        node.label = "Late " + node.label;
                    }
                }
                this.nodes.push(node);
            }
        }
    }

    createLinkForRelatives(relative: Relative, relativeList: Relative[]) {
        // console.log(relative.name, relative.relation)
        if (relative.name && relative.name.length > 0) {
            switch (relative.relation) {
                case "Brother": {
                    let parent = this.links.find(x => x.target == relative.emp_id && (x.label == 'Son' || x.label == 'Daughter'))
                    if (parent) {
                        this.createLink(parent.source, relative.relative_id, 'Son', relative.id);
                    }
                    break;
                }
                case "Sister": {
                    let parent = this.links.find(x => x.target == relative.emp_id && (x.label == 'Son' || x.label == 'Daughter'))
                    if (parent) {
                        this.createLink(parent.source, relative.relative_id, 'Daughter', relative.id);
                    }
                    break;
                }
                case "Son": { this.createLink(relative.emp_id, relative.relative_id, 'Son', relative.id); break; }
                case "Daughter": { this.createLink(relative.emp_id, relative.relative_id, 'Daughter', relative.id); break; }
                case "Father": {
                    let mother = relativeList.find(x => x.relation == 'Mother');
                    let link
                    if (mother) {
                        link = this.links.find(x => x.source == mother.relative_id && x.target == mother.emp_id);
                    }
                    if (!link) {
                        this.createLink(relative.relative_id, relative.emp_id, relative.gender == 'MALE' ? 'Son' : 'Daughter', relative.id);
                    }
                    break;
                }
                case "Mother": {
                    let relFather = relativeList.find(x => x.relation == 'Father' && x.emp_id == relative.emp_id);
                    if (relFather) {
                        this.createSpouse(relFather.relative_id, relative.name, relative.relative_id, relative.url, 'female');
                    }
                    break;
                }
                // case "Mother": { this.setFatherMother(relative, relativeList, 'Father'); break; }
                case "Wife": { this.createSpouse(relative.emp_id, relative.name, relative.relative_id, relative.url, 'female'); break; }
                case "Husband": { this.createSpouse(relative.emp_id, relative.name, relative.relative_id, relative.url, 'male'); break; }
            }
        }
    }

    createSpouse(emp_id, name, id, url, gender) {
        let node = this.nodes.find(x => x.id == emp_id);
        if (node) {
            if (!node.data) {
                node.data = {};
            }
            node.data.spouse = name + " Ji";
            node.data.spouse_id = id;
            node.data.spouse_url = url ? url : gender == 'male' ? './assets/imgs/male.png' : './assets/imgs/female.png';
        }
    }

    createLink(source, target, label, relativeId) {
        let link: any;
        if (!environment.production) {
            console.log(this.links);
        }
        link = this.links.find(x => x.source == source && x.target == target);
        if (!environment.production) {
            console.log(source, target, label, link);
        }
        if (!link) {
            let chars: string = 'abcdefghijklmnopqrstuvwxyz';
            let result = '';
            for (let i = 5; i > 0; --i) {
                result += chars[Math.floor(Math.random() * chars.length)];
            }

            link = {
                id: result + this.links.length,
                source: source,
                target: target,
                label: label,
                // label: label == 'Daughter' ? 'Daughter' : 'Son',
                relativeId: relativeId
            }
            this.links.push(link);
        }
        return link;
    }

    deleteNode(id) {
        this.nodes = this.nodes.filter(x => x.id != id);
        this.links = this.links.filter(x => x.source != id && x.target != id);
        console.log("Node deleted", this.nodes);
    }


    refresh() {
        UtilityTs.sortNumberInObject(this.nodes, "age", true);
        UtilityTs.sortNumberInObject(this.links, "age", true);
        // for (let link of this.swim.links) {
        //   console.log(link.label, link.name, link.age);
        // }
        // console.log(this.swim.nodes);
        // console.log(this.swim.links);

        // let nodeString = JSON.stringify(this.nodes);
        // console.log(this.nodes);
        // this.nodes = [...JSON.parse(nodeString)];
        // console.log(this.nodes);
        for (let node of this.nodes) {
            delete node.dimension;
            delete node.position;
            delete node.transform;
            //   if (this.selectedNode && node.id != this.selectedNode.id) {
            //     node.data.color = "#00CDED";
            //   } {
            //     node.data.color = "#AACDED";
            //   }
        }

        this.update$.next(true);
        // this.zoomToFit$.next(true);

    }

}